import React, { useState } from 'react';
import './AuthForm.css'; // Ensure you create/update this CSS file
import img1 from "../../Components/Images/Alcon1.jpg"
import axios from 'axios'
import {useLocation, useNavigate } from "react-router";

const AuthForm = () => {


  let navigate = useNavigate();
     const LOGIN_URL = '/auth';
    //const BASE_URLLOCAL ="http://localhost:2002"
    const BASE_URLLOCAL ="https://lencopay.onrender.com"
  const [isSignIn, setIsSignIn] = useState(true);
  const [loginState, setLogin] = useState(true); 
  const [forgotPwdState, setForgotPwdStaten] = useState(false); 
  const [sucessRecovery, setSucessRecovery] = useState(false); 
  const [register, setRegister] = useState(false);
  const [Branch, setBranch] = useState("");
  const [OrgName, setOrgName] = useState("");
  const [Address, setAddress] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [AccNo, setAccNo] = useState("");
  const [Loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [Msg, setMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log(formData);
  // };

  const handleSubmit = async (e) => {
    // e.preventDefault();
    e.preventDefault();  
    setLoading(true)
    setSuccessMsg(false);
    setErrorMsg(false);
   
    // const from = location?.state?.from?.pathname || "/UserDash";
    const from = location?.state?.from?.pathname || "/dash";

    try {
       // console.log("email",email,"and",password)
        const response = await axios.post(BASE_URLLOCAL+LOGIN_URL,
            JSON.stringify({   email : formData.email, password : formData.password }),
            // JSON.stringify({ user, pwd }),
            {
                headers: { 'Content-Type': 'application/json',
                // 'Access-Control-Allow-Credentials': 'true' ,
                // 'Origin': 'https://www.google.com/'
                // 'Origin': 'http://localhost:3000'
             },
                
                withCredentials: true,
                crossDomain: true,

            }
        );
        // if(response){
        //   console.log(response)
        // }
       // if(response?.data?.accessToken !=""){
        if(response?.data?.status =="Ok"){
          console.log(response)
          navigate("/dash");

            // console.log("whole",JSON.stringify(response?.data));
          //  console.log(JSON.stringify(response));
            const user = response?.data?.email;
            const accessToken = response?.data?.accessToken;
            const roles = response?.data?.roles;
            const foundUser = response?.data?.foundUser;
            // setAuth({});
            // setAuth({ user, roles : [roles,"test role"], accessToken, foundUser});
            // setAuth({ user, pwd, roles, accessToken });
            //console.log("autheeeeee",auth)
            setLoading(false)
       
        // alert("login successful!");
         
       // navigate(from,{replace: true});

        }else{  

            setLoading(false);
            setMsg(response?.data?.msg)
            setErrorMsg(true);
            
        }
        
        // navigate(from, { replace: true });
    } catch (err) {
       
    }
}

  return (
    <div className="auth-container">
      <div className="auth-image">
        <img src={img1} alt="Beauty Products" />
      </div>
      <h2>{isSignIn ? 'Sign In' : 'Sign Up'}</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />
        {!isSignIn && (
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        )}
        <button type="submit">{isSignIn ? 'Sign In' : 'Sign Up'}</button>
      </form>
      <p>
        {isSignIn ? 'Need an account? ' : 'Already have an account? '}
        <span onClick={() => setIsSignIn(!isSignIn)} className="toggle-link">
          {isSignIn ? 'Sign Up' : 'Sign In'}
        </span>
      </p>
    </div>
  );
};

export default AuthForm;
